module.exports = __webpack_public_path__ + "img/no-company-evidence.235aeb07.svg";